import Pusher from 'pusher-js';

function csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
}

export async function chatRequest(path, options = {}) {
    const isMultipart = typeof FormData !== 'undefined' && options.body instanceof FormData;
    const headers = {
        Accept: 'application/json',
        'X-CSRF-TOKEN': csrfToken(),
        ...(isMultipart ? {} : {'Content-Type': 'application/json'}),
        ...(options.headers || {}),
    };
    const response = await fetch(path, {
        credentials: 'include',
        ...options,
        headers,
    });

    if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        const validation = payload.errors ? Object.values(payload.errors).flat()[0] : null;
        throw new Error(validation || payload.message || '상담 요청을 처리하지 못했습니다.');
    }

    return response.status === 204 ? null : response.json();
}

export async function loadCapability() {
    return chatRequest('/api/customer-chat/capability');
}

export function connectRealtime(capability, channelName, handlers = {}, connectionHandlers = {}) {
    if (!capability?.realtime?.enabled) {
        return null;
    }

    const realtime = capability.realtime;
    const options = {
        cluster: realtime.cluster || 'mt1',
        wsHost: realtime.host,
        wsPort: realtime.port,
        wssPort: realtime.port,
        forceTLS: realtime.scheme === 'https',
        enabledTransports: ['ws', 'wss'],
        enableStats: false,
        channelAuthorization: {
            endpoint: connectionHandlers.authEndpoint || realtime.auth_endpoint,
            transport: 'ajax',
            headers: {'X-CSRF-TOKEN': csrfToken()},
        },
    };

    if (realtime.path) {
        options.wsPath = realtime.path;
    }

    connectionHandlers.onConnecting?.();

    const pusher = new Pusher(realtime.key, options);
    const channel = pusher.subscribe(channelName);
    let disposed = false;
    let subscribed = false;

    const connected = () => {
        if (disposed || subscribed) return;
        subscribed = true;
        connectionHandlers.onConnected?.();
    };
    const disconnected = (reason = null) => {
        if (disposed) return;
        subscribed = false;
        connectionHandlers.onDisconnected?.(reason);
    };

    Object.entries(handlers).forEach(([event, handler]) => channel.bind(event, handler));
    channel.bind('pusher:subscription_succeeded', connected);
    channel.bind('pusher:subscription_error', error => disconnected({type: 'subscription_error', error}));
    pusher.connection.bind('connecting', () => connectionHandlers.onConnecting?.());
    pusher.connection.bind('disconnected', () => disconnected({type: 'disconnected'}));
    pusher.connection.bind('unavailable', () => disconnected({type: 'unavailable'}));
    pusher.connection.bind('failed', () => disconnected({type: 'failed'}));
    pusher.connection.bind('error', error => connectionHandlers.onError?.(error));

    return () => {
        disposed = true;
        pusher.unsubscribe(channelName);
        pusher.disconnect();
    };
}
